/* eslint-disable react/jsx-pascal-case */
import Modals from '@va/dashboard/shared/modals/index';

export default function AaasModals() {
  return (
    <>
      {/*<Modals.AnnouncementModal />*/}
      <Modals.SsrTechnicalLimitation />
      <Modals.SsrReachedLimit />
      <Modals.ManualScreenshotContainer />
      <Modals.VisitsLimitReached />
      <Modals.VideoOverlay />
      <Modals.TabInformation />
      <Modals.FeatureLimitReached />
      <Modals.AaasFreeTrialEndingModal />
      <Modals.AaasFreeTrialEndedModal_14Days_AccountSubscription_NoFreePlan />
      <Modals.AaasSubscriptionEndedModal_AccountSubscription_NoFreePlan />
    </>
  );
}
